// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1140":"fc94fd22","1631":"0d72b53d","2113":"2ffb4858","3641":"377c00d5","4095":"4839a770","5159":"c4b70ef7","8205":"a79da961","9056":"11c1fd03","9853":"c3a71a48"}[chunkId] + ".chunk.css";
};